var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.279px",
    height: "459.21px",
    viewBox: "0 0 595.279 459.21",
    enableBackground: "new 0 0 595.279 459.21",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M298.827,222.153c56.229,0,108.135,18.425,150.114,49.468L298.813,59L148.662,271.658 C190.661,240.578,242.551,222.153,298.827,222.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M298.813,277.443c97.101,0,182.791,48.908,233.783,123.443c-37.949-91.779-128.292-156.363-233.783-156.363 c-105.504,0-195.871,64.584-233.813,156.363C115.992,326.351,201.664,277.443,298.813,277.443z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company-logo.be55f5ec63e57cf84920ba19d34b2bf7.svg";
export { ForwardRef as ReactComponent };